import { toDataSourceRequestString } from "@progress/kendo-data-query";
import { createApi } from "@reduxjs/toolkit/query/react";
import type { ListAdminKnowledgeInsightsRequest, ListKnowledgeInsightsResponse } from "../../contracts";
import { baseQueryAdminWithAuth } from "../api";

export const adminKnowledgeInsightApi = createApi({
    reducerPath: "adminKnowledgeInsightApi",
    baseQuery: baseQueryAdminWithAuth,
    endpoints: builder => ({
        listKnowledgeInsights: builder.query<ListKnowledgeInsightsResponse, ListAdminKnowledgeInsightsRequest>({
            query: body => ({
                url: `knowledgeinsight/list?${toDataSourceRequestString(body)}`,
                method: "POST",
                body
            })
        })
    })
});

export const { useListKnowledgeInsightsQuery } = adminKnowledgeInsightApi;
